module.exports = __webpack_public_path__ + "img/4.78833066.jpg";